import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import Edit from '../../../moreCore/UI/Edit/Edit';
import MaintenanceTaskForm from './MaintenanceTaskForm';
import template from './MaintenanceTaskList.html?raw';

class MaintenanceTaskList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    isExternalEmployee = false;

    entitylist: any = null;

    _totalCount = 0;
    _currentOffset = 0;
    _nextOffset: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    setResult(resultlist: any, offset: any, nextOffset: any): void {
        this.StandbyStop();

        console.log("MaintenanceTaskList new result", resultlist, offset, nextOffset);

        if (offset > 0) {
            this._addListToList(resultlist, offset);
        } else {
            this._prepareNewList(resultlist);
        }

        this._nextOffset = nextOffset;

    }

    _prepareNewList(response: any): void {

        this.StandbyStop();
        this.entitylist = response.entitylist;
        this._totalCount = response.totalResultCount;
        this._currentOffset = 0;

        domAttr.set(this.txtTotalCount, "innerHTML", this._totalCount);

        console.log("_prepareNewList", this.entitylist);

        this._renderTable();
    }

    _addListToList(resultlist: any, newOffset: any): void {
        this.StandbyStop();
        this._totalCount = resultlist.totalResultCount;

        domAttr.set(this.txtTotalCount, "innerHTML", this._totalCount);

        if (this.entitylist == null) {
            this.entitylist = [];
        }

        this.entitylist = this.entitylist.concat(resultlist.entitylist);

        if (typeof (newOffset) == "number") {
            this._currentOffset = newOffset;
        }

        if (this._totalCount == 0) {
            this._renderTable();
        } else {
            this._renderTable(resultlist.entitylist);
        }
    }

    _renderTable(entitylist?: any): void {

        var taskList = this.entitylist;

        if (this._totalCount > taskList.length) {
            domClass.remove(this.btnLoadNext, "w3-disabled");
        } else {
            domClass.add(this.btnLoadNext, "w3-disabled");
        }

        domConstruct.empty(this.listContainer);

        if (taskList.length > 0) {
            domClass.add(this.noResultNode, "w3-hide");
            domClass.remove(this.listContainer, "w3-hide");


        } else {
            domClass.remove(this.noResultNode, "w3-hide");
            domClass.add(this.listContainer, "w3-hide");
            domClass.add(this.btnLoadNext, "w3-hide");

            return;
        }

        domClass.remove(this.btnLoadNext, "w3-hide");

        this.txtCurrentCount.innerHTML = taskList.length;

        // employeeTasksContainer
        this.employeeTasksTable = new Tabulator(this.listContainer, {
            data: taskList,
            selectableCheck: lang.hitch(this, this.tableSelectableCheck),
            layout: "fitColumns",
            index: "ID", // WIESO GEHT DES NED?!
            rowClick: lang.hitch(this, this.clickRow),
            //height: "311px",
            rowFormatter: lang.hitch(this, this.rowFormatter),
            columns: [
                {
                    title: this.translations["MaintenanceTaskList__TableCol_TaskNumber"]/*"Nummer"*/,
                    field: "ref_vt_task.Number",
                    width: 100,
                    editor: false,
                    headerSort: false
                },
                {
                    title: this.translations["MaintenanceTaskList__TableCol_Target"]/*"Status"*/,
                    field: "ref_vt_task.Task___ref_managed_object.tmp_label",
                    width: 220,
                    editor: false,
                    //formatter: ,
                    headerSort: false
                },
                {
                    title: this.translations["MaintenanceTaskList__TableCol_TaskDescription"]/*"Nummer"*/,
                    field: "ref_vt_task.tmp_description_www",
                    editor: false,
                    headerSort: false
                },
                {
                    title: this.translations["MaintenanceTaskList__TableCol_Status"]/*"Status"*/,
                    field: "ref_scheduled_task_executer_status.Name",
                    width: 120,
                    editor: false,
                    formatter: lang.hitch(this, this.tableFormatterStatus),
                    headerSort: false
                },

                {
                    title: this.translations["MaintenanceTaskList__TableCol_TargetDate"]/*"zu erledigen bis"*/,
                    field: "ref_vt_task.Ausfuehrung_bis",
                    width: 120,
                    editor: false,
                    formatter: this.tableFormatterDateTime,
                    headerSort: false
                },

                //{
                //    title: this.translations["OccurrenceTaskList__TableCol_Actions"]/*"Aktionen"*/,
                //    field: "ID",
                //    formatter: lang.hitch(this, "tableBtnActions"),
                //    headerSort: false
                //}

            ]
        } as any);

        domStyle.set(this.listContainer, "fontSize", "0.8rem");

    }

    _onClick_Btn_LoadNext(evt: any): void {
        this.emit("loadNextResults", this._nextOffset);
    }

    tableSelectableCheck(row: any): any {
        //var data = row.getData();

        return true;
    }

    rowFormatter(row: any): void {
        //var data = row.getData();
    }

    clickRow(evt: any, row: any): void {

        var data = row.getData();

        if (this.tableSelectableCheck(row) != true) // also Editorrecht ist auch keins?
        {
            return;
        }

        //console.debug("clickRow", data);;

        this.showMaintenanceTaskForm(data.ID);
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any): any { //plain text value

        var data = cell.getRow().getData();
        var buttonStates = JSON.parse(data.tmp_buttonstates);

        var container = domConstruct.create("div");
        domClass.add(container, "flex_row");
        domStyle.set(container, "gap", "0.5em");
        //console.log("tableBtnActions", data, buttonStates);


        if (buttonStates.button_complete === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fas fa-check'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Finish"] /*erledigen"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_FinishTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__CompleteTask", data));
        }

        if (buttonStates.button_pause === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fas fa-pause'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Pause"] /*unterbrechen"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_PauseTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__PauseTask", data));
        }

        if (buttonStates.button_start === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fas fa-play'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Start"] /*Bearbeitung starten"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_StartTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__StartTask", data));
        }

        if (buttonStates.button_maintenance === true) {
            var button = domConstruct.create("button");
            domClass.add(button, "mds-button-base round mds-bg-gray mds-hover-dark");
            domAttr.set(button, "innerHTML", "<i class='fas fa-clipboard-list'>&nbsp;</i>" + this.translations["OccurrenceTaskExecutions__TableBtn_Maintenance"] /*Bearbeitung starten"*/);
            domAttr.set(button, "title", this.translations["OccurrenceTaskExecutions__TableBtn_MaintenanceTooltip"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__ShowMaintenance", data));
        }

        setTimeout(lang.hitch(cell, "checkHeight"), 200);

        return container;

    }


    _onClick__ShowMaintenance(exec: any, evt: any): void {

        if (evt) {
            evt.stopPropagation();
        }

        this.showMaintenanceTaskForm(exec.ID);
    }

    _onClick__PauseTask(taskEntity: any, evt: any): void {
        let header = this.translations["OccurrenceTaskExecutions__DialogPauseHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogPause"].format(taskEntity.Number);

        if (evt) {
            evt.stopPropagation();
        }
    }

    _onClick__CompleteTask(taskEntity: any, evt: any): void {

        //dialog.set("SubTitle", "Die Ausführung zu Auftrag " + taskEntity.Number + " wird erledigt und eine Nachricht an den Meldenden geschickt.<br>Möchten Sie eine Anmerkung hinzufügen?");
        //dialog.set("SubTitle", this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number));

        let header = this.translations["OccurrenceTaskExecutions__DialogConfirmFinishHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number);

        if (evt) {
            evt.stopPropagation();
        }

    }

    _onClick__StartTask(taskEntity: any, evt: any): void {
        //console.debug("_onClick__StartTask", taskEntity);
        if (evt) {
            evt.stopPropagation();
        }
        this._changeExecuterStatus(taskEntity, "ID_scheduled_task_executer_status_active");


    }

    _changeExecuterStatus(taskEntity: any, targetState: any, result?: any): void {

        var note = this.taskInput.value;
        var data = {
            Note: note,
            Assistants: this._assistantData,
            Flatrates: this._flatratesData,
            Material: this._materialData,
            Workamount: parseFloat(this.inputWorkingAmount.value),
            targetState: targetState
        };


        //console.debug("_changeExecuterStatus", result, taskEntity, data);

        // antwort vom Dialog? (bei Pausieren)
        if (typeof (result) != "undefined") {

            if (result < 1) { // Abbruch
                return;
            }

        }

        this.StandbyStart();

        var url = window.appRoot + "JDM/ChangeExecuterStatus";

        this.RequestManager.post(
            url,
            {
                taskID: taskEntity.ID,
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onChangeExecuterStatusResponse"),
            lang.hitch(this, "_onChangeExecuterStatusError"),
            false // sync
        );

    }

    _onClick__AcceptTask(taskEntity: any, evt: any): void {
        this.StandbyStart();

        var url = window.appRoot + "JDM/AcceptTaskJSON";

        this.RequestManager.post(
            url,
            {
                taskID: taskEntity.ID
            },
            lang.hitch(this, "_onChangeExecuterStatusResponse"),
            lang.hitch(this, "_onChangeExecuterStatusError"),
            false // sync
        );

        if (evt) {
            evt.stopPropagation();
        }
    }

    _onChangeExecuterStatusResponse(): void {
        //this.loadScheduledTaskExecutors();
        this.emit("ExecutersChanged");
        this.StandbyStop();

        if (this._flatratesSelect) {
            this._flatratesSelect.destroy();
            this._flatratesSelect = null;
            this._flatratesData = null;
            domConstruct.place(this.inputDiv, this.domNode);
            domClass.add(this.inputDiv, "w3-hide");
            domConstruct.empty(this.errorMessage);
        }

        if (this._itemSelect) {
            this._itemSelect.destroy();
            this._itemSelect = null;
        }

        this._materialData = null;
        domConstruct.empty(this.materialTableContainer);

        //domConstruct.place(this.assistantContainer, this.domNode);
        //domClass.add(this.assistantContainer, "w3-hide");

        if (this._statusChangeDlg) {
            setTimeout(domConstruct.destroy(this._statusChangeDlg.domNode) as any, 1000);

            this._statusChangeDlg = null;
        }
    }
    _onChangeExecuterStatusError(error: any): void {
        this.StandbyStop();
        alert(error.Message);

        if (this._statusChangeDlg) {
            this._statusChangeDlg.show();
        }
    }


    _onCompleteTaskCallback(taskEntity: any, result: any): void {

        if (result != 1) {
            return;
        }

        this.StandbyStart();

        var url = window.appRoot + "JDM/CompleteTask";

        this.RequestManager.post(
            url,
            {
                taskID: taskEntity.ID,
                jsonData: JSON.stringify((window as any).data) // JS2TS: 'data' was an undefined reference in the original (latent bug); preserved as a global read to compile
            },
            lang.hitch(this, "_onCompleteTaskResponse"),
            lang.hitch(this, "_onCompleteTaskError"),
            false // sync
        );

        domConstruct.empty(this.errorMessage);
    }
    _onCompleteTaskResponse(): void {
        //this.loadScheduledTaskExecutors();
        this.emit("ExecutersChanged");
        this.StandbyStop();
    }
    _onCompleteTaskError(error: any): void {
        alert(error.Message);
        this.StandbyStop();
    }

    tableFormatterDateTime(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        //console.log("tableFormatterDateTime", data);

        if (value == "") {
            return "";
        }

        var date = new Date(value);

        //value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "dd.MM.yyyy", timePattern: "HH:mm" });

        // bei "zu erledigen bis" Rotfärbung falls datum abgelaufen und noch nicht erledigt!
        if (cell.getField() == "To_complete_by") {

            if (date < new Date()) {
                var dom = cell.getElement();
                domStyle.set(dom, "color", "red");
            }
        }

        return value;
    }

    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any): any {

        var data = cell.getData();
        var value = cell.getValue();

        //console.debug("tableFormatterStatus", data);

        let rawColor = null;
        if (data.ref_scheduled_task_executer_status) { // bei der Unterliste mit Ausführungen!
            rawColor = data.ref_scheduled_task_executer_status.DisplayColor;
        }

        if (rawColor == null || typeof (rawColor) == "undefined") {
            return value;
        }

        //console.log("occurrenceTaskList tableFormatterStatus color", rawColor, data.ref_status);

        var rawTextColor = "000000";

        if (typeof (rawColor) == "object" && rawColor != null) {

            var hexColor = rawColor.BackColor.Hex;
            domStyle.set(cell.getElement(), "background-color", hexColor);

            hexColor = rawColor.TextColor.Hex;
            domStyle.set(cell.getElement(), "color", hexColor);

        } else {
            var hexColor: any = "#ccc";
            domStyle.set(cell.getElement(), "background-color", hexColor);

            hexColor = "330000";
            domStyle.set(cell.getElement(), "color", hexColor);
        }


        return value;
    }

    showMaintenanceTaskForm(entityID: any): void {
        var dlg = new GenericDialog();

        dlg.set("TopCloseBtn", true);
        dlg.set("closeBtn", true);
        dlg.set("cancelBtn", false);
        dlg.set("header", this.translations["General_Loading"]);

        dlg.set("callback", lang.hitch(this, this._onGetMaintenanceTaskFormResult));

        var form = new MaintenanceTaskForm();
        form.set("entityID", entityID);

        on(form, "EntityChange", lang.hitch(dlg, function (entity) {
            this.set("header", entity._title);

            var colorBG = "var(--tertiary)";
            var colorTXT = null;

            if (entity.ref_scheduled_task_executer_status.DisplayColor) {
                if (entity.ref_scheduled_task_executer_status.DisplayColor.BackColor) {
                    if (!entity.ref_scheduled_task_executer_status.DisplayColor.BackColor.IsNull) {
                        colorBG = entity.ref_scheduled_task_executer_status.DisplayColor.BackColor.Hex;
                        colorBG += "88"; // Transparenz
                    }
                }

                if (colorBG) {
                    colorTXT = entity.ref_scheduled_task_executer_status.DisplayColor.TextColor.Hex;
                }
            }
            domStyle.set(dlg.modalDlgContentNode, "boxShadow",
                "0px 0px 0px 4px " + colorBG + ", " +
                "0px 0px 16px 0px #00000077");

            dlg.enableButton("createOccurrence");
        }));

        on(form, "EntityStored", this.emit("reloadRequested", 0));

        form.startup();

        dlg.hideSubtitleNode();
        dlg.addNodeToContent(form.domNode);
        dlg.show();

        if (true) {
            dlg.addButton("createOccurrence",
                this.translate("MaintenanceTaskList__Label_CreateFollowupOccurrence"),
                lang.hitch(this, this._onCreateOcc, form),
                null,
                null,
                "fas fa-exclamation-circle w3-text-deep-orange",
                false,
                "left first",
                false);
        }

        this.setUrlParameter("view", entityID);
    }

    _onGetMaintenanceTaskFormResult(result: any): void {
        //console.debug("_onGetMaintenanceTaskFormResult", result);
        this.removeUrlParameter("view");
    }

    _onCreateOcc(form: any, evt: any): void {
        let entity = form.getEntity();

        console.info("occurrence creating", entity);

        let input = new Edit();
        input.setIsMultiline(true);
        input.set("label", this.translate("General_Label_ProblemDescription"));
        input.set("mandatory", true);

        let dlg = new GenericDialog();
        dlg.keepOpen = true;


        //dlg.show("content", "header", "subtitle", "fas fa-warning", lang.hitch(this, this._onOccDlg), "saveclose");
        dlg.show(input,
            this.translate("MaintenanceTaskList__Label_CreateFollowupOccurrence"),
            this.translate("MaintenanceTaskList__Msg_CreateFollowupOccurrence"), // subtitle
            null,// icon
            "submitcancel",
            lang.hitch(this, this._onOccDlg, input, entity, dlg));

    }

    _onOccDlg(input: any, executionEntity: any, dlg: any, result: any): void {
        if (result >= 1) {
            let value = input.get("value");
            if (!value) {
                dlg.show();
                alert(this.translate("General_Label_ProblemDescription") + " nicht ausgefüllt!");
                return;
            }

            let data = {
                "executionID": executionEntity.ID,
                "description": value
            }

            dlg.disableAllButtons();
            this.StandbyStart(input.domNode);

            let url = window.appRoot + "JDM/CreateOccurrenceFromExecution";

            this.RequestManager.post(
                url,
                {
                    jsonData: JSON.stringify(data)
                },
                lang.hitch(this, this._onCreateOccResult, dlg),
                lang.hitch(this, this._onCreateOccError, dlg),
                false // sync
            );
        } else {
            dlg.close(-1, true);
        }
    }

    _onCreateOccError(dlg: any, error: any): void {
        this.StandbyStop();
        dlg.disableAllButtons(false);

        alert(error.Message);
    }
    _onCreateOccResult(dlg: any, result: any): void {
        this.StandbyStop();
        dlg.close(-1, true);

        this.showToast(this.translate("General_SavingSuccessful"), "fas fa-check w3-text-green");
    }

}
MaintenanceTaskList.prototype.declaredClass = 'WidgetCollection.Maintenance.MaintenanceTaskList';

export default mdsWidget(MaintenanceTaskList);
